import { render, staticRenderFns } from "./WorkExampleSlides.vue?vue&type=template&id=0e0b6ca5&scoped=true&"
import script from "./WorkExampleSlides.vue?vue&type=script&lang=js&"
export * from "./WorkExampleSlides.vue?vue&type=script&lang=js&"
import style0 from "./WorkExampleSlides.vue?vue&type=style&index=0&id=0e0b6ca5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0b6ca5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
